import { SKOS } from "../sgov-vocabulary.js";
export async function loadSgovEntityToResource(entity, idProvider, resource) {
    const prefLabel = await entity.property(SKOS.prefLabel);
    resource.pimHumanLabel = rdfObjectsToLanguageString(prefLabel);
    const definition = await entity.property(SKOS.definition);
    resource.pimHumanDescription = rdfObjectsToLanguageString(definition);
    resource.pimInterpretation = entity.iri;
    resource.iri = idProvider.cimToPim(resource.pimInterpretation);
}
function rdfObjectsToLanguageString(objects) {
    return Object.fromEntries(objects.map((o) => [o.language, o.value]));
}
//# sourceMappingURL=sgov-entity-adapter.js.map